import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

// picks productcompare from Adobe Target delivery API response: execute.pageLoad.options
const offerSelector = createSelector(testTargetOffersSelector, abTest => abTest.productcompare);

// Hidden by default: missing offer or any value other than show:true keeps compare off.
const showSelector = createSelector(offerSelector, productcompare => productcompare?.show === true);

/**
 * Returns true when Adobe Target is ready and productcompare.show is explicitly true.
 * Returns false when the offer is missing, show is false, or show is not explicitly true.
 * @param {object} state - Redux state
 * @returns {boolean}
 */
const showPlpProductCompareSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showPlpProductCompareSelector };
